import { render, staticRenderFns } from "./cancellation.vue?vue&type=template&id=2e8b9a02&scoped=true"
import script from "./cancellation.vue?vue&type=script&lang=js"
export * from "./cancellation.vue?vue&type=script&lang=js"
import style0 from "./cancellation.vue?vue&type=style&index=0&id=2e8b9a02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8b9a02",
  null
  
)

export default component.exports